import { createContext } from 'react';

const IsInTaskAttachmentViewContext = createContext<boolean>(false);

export default IsInTaskAttachmentViewContext;
